(function() {
	'use strict';

	angular.module('quantixApp').controller('UserNotification',
			UserNotification);

	UserNotification.$inject = [ '$scope', '$window', '$uibModal', '$timeout',
			'$state', '$anchorScroll', 'CompanyIndAlertService', '$rootScope',
			'industryService' ];

	function UserNotification($scope, $window, $uibModal, $timeout, $state,
			$anchorScroll, CompanyIndAlertService, $rootScope, industryService) {
		var vm = this;
		$scope.error = false;
		$scope.tabid = '';
		$scope.setInnerTabSetData = function(tabid) {
			$scope.tabid = tabid;
			$scope.filterTxn.notificationType = $scope.tabid;
			$scope.platformFilterNotificationList = [];
			console.log("notification list ",$scope.platformNotificationList);
			if(tabid == ''){
				$scope.platformFilterNotificationList=$scope.platformNotificationList;
			}
			 angular.forEach($scope.platformNotificationList, function(value, key){
			      if(value.notificationType == $scope.filterTxn.notificationType)
			    	  $scope.platformFilterNotificationList.push(value);
			   });
		}

		$scope.filterTxn = {
			notificationType : ''
		};
		
		$(".toptabsec ul li a").click(function() {
			$(".toptabsec ul li a").removeClass("active");
			$(this).addClass("active");
		});

		$scope.getClass = function(alertType) {

			switch (alertType) {
			case "COMPANY":
				return "notif-label1";
				break;
			case "INDUSTRY":
				return "notif-label2";
				break;
			case "PORTFOLIO":
				return "notif-label3";
				break
			case "COMPANY_REPORT":
				return "notif-label4";
				break;
			case "ESG_Alert":
				return "notif-label5";
				break;

			}

		}

		$scope.platformNotificationList = [];
		$scope.userNotification = {
			platformNotificationList : []
		};

		$scope.userPlatformNotificationDetails = function(page) {
			
			 var fd = new FormData();
			fd.append('pageNumber', page);

			CompanyIndAlertService.userPlatformNotificationDetails(fd).then(
					function(data) {
						if (data != null) {

							$scope.platformNotificationList = data;
							$scope.platformFilterNotificationList =$scope.platformNotificationList ;
							$scope.paginationCodeForUserAlert(page);
						}

					}, function(errordata) {
						vm.entityResponse = errordata;
						$scope.errorMessage = vm.entityResponse.message;
						$scope.error = true;
						$timeout(function() {

							$scope.error = false;
							$scope.errorMessage = "";

						}, 2000);
					});
		}

		$scope.redirectToAlertType = function(platformDto) {

			if (platformDto.notificationSentFlag == 'N') {

				CompanyIndAlertService.userPlatformNotificationSavedSentStatus(
						platformDto).then(function(data) {

				}, function(errordata) {
					vm.entityResponse = errordata.data;
					$scope.errorMessage = vm.entityResponse.message;
					$scope.error = true;
					$timeout(function() {

						$scope.error = false;
						$scope.errorMessage = "";

					}, 2000);
				});

				$timeout(function() {
					$rootScope.$emit("callTopFiveNotification");

				}, 100)

			}
			if (platformDto.type == 'cr' && platformDto.typeId != "") {
				$state.go('companyreport');
				$anchorScroll();
			}
			if (platformDto.type == 'company' && platformDto.typeId != "") {

				if (platformDto.sectionType == 'rating') {
					$state.go('ratingInformation', {
						'companyCode' : platformDto.typeId,
						'companyName' : platformDto.label
					});
					$anchorScroll();
				} else {
					$state.go("companyDetails", {
						sectionId : platformDto.section,
						companyCodeToview : platformDto.typeId,
						companyCode : platformDto.typeId
					});
				}

			} else if (platformDto.type == 'industry'
					&& platformDto.typeId != "") {

				$scope.industryObj = {
					"id" : platformDto.typeId,
					"label" : platformDto.label
				};

				industryService
						.getAggFinancials(platformDto.typeId)
						.then(
								function(response) {
									industryService.getRecentlyViewed(
											$scope.industryObj).then(
											function(response) {

											}, function(reject) {

											})

									$scope.listformovements = {};
									$scope.listformovements.upwards = response[0][0];
									$scope.listformovements.downwards = response[0][1];
									$scope.listformovements.mixed = response[0][2];
									$scope.outputParameters = response[1];
									$scope.dataForIndustryIndicator = response[2];
									$scope.dataForDrillDown = response[3];
									$scope.newsdata = response[5];
									$scope.industryType = response[4];
									$scope.loaddir = true;
									$state
											.go(
													"industryProfileDetails",
													{
														drill : $scope.dataForDrillDown,
														indicator : $scope.dataForIndustryIndicator,
														objtodisplay : $scope.outputParameters,
														movements : $scope.listformovements,
														industryId : $scope.companyCode,
														industryName : $scope.industryObj.label,
														industryAlertFlag : $scope.industryObj.industryAlertFlag,
														news : $scope.newsdata,
														industryType : $scope.industryType,
														label : $scope.industryObj.label
													});

									$anchorScroll();
								},
								function(error) {
									vm.entityResponse = error.data;
									$scope.errorMessage = vm.entityResponse.message;
									$scope.error = true;
									$timeout(function() {

										$scope.error = false;
										$scope.errorMessage = "";

									}, 2000);
								});
			} else if (platformDto.type == 'port' && platformDto.typeId != "") {

				$state.go('portfolioLanding', {
					'portfolioId' : platformDto.typeId,
					'portfolioName' : platformDto.typeId
				});
				$anchorScroll();
			}else if (platformDto.type == 'esg_alert' && platformDto.typeId != "") {
				$window.location.href='/esg/companyreport?companyCode='+platformDto.typeId+'&'+'sectorName=Hotels&companyName='+platformDto.label;
				$anchorScroll();
			}

		}

		$scope.deletePlatformAlert = function() {

			if ($scope.userNotification.platformNotificationList.length > 0) {
				if ($window
						.confirm("Are you sure you want to Delete this Platform Alert ?")) {
					CompanyIndAlertService
							.deletePlatformsAlert(
									$scope.userNotification.platformNotificationList)
							.then(
									function(result) {

										$scope
												.userPlatformNotificationDetails(1);
										$scope.userNotification.platformNotificationList = [];
										$timeout(
												function() {
													$rootScope
															.$emit("callTopFiveNotification");
												}, 100)
									},
									function(response, status, headers, config) {

										vm.entityResponse = response.data;
										$scope.errorMessage = vm.entityResponse.message;
										//$scope.errorMessage = "Error occured while remove Alert"
										$scope.error = true;
										$timeout(function() {

											$scope.error = false;
											$scope.errorMessage = "";

										}, 2000);

									});
				}
			}

		}

		$scope.clearAll = function() {
			var type = "";
			if ($scope.platformNotificationList.length > 0) {
				if ($scope.tabid == '') {
					type = "ALL";
				} else {
					type = $scope.tabid;
				}
				CompanyIndAlertService
						.clearAllPlatformsAlert(type)
						.then(
								function(result) {

									$scope.userPlatformNotificationDetails(1);
									$scope.userNotification.platformNotificationList = [];
									$timeout(
											function() {
												$rootScope
														.$emit("callTopFiveNotification");
											}, 100)
								},
								function(response, status, headers, config) {
									vm.entityResponse = response.data;
									$scope.errorMessage = vm.entityResponse.message;
									//$scope.errorMessage = "Error occured while clear all Notification"
									$scope.error = true;
									$timeout(function() {

										$scope.error = false;
										$scope.errorMessage = "";

									}, 2000);

								});

			}

		}
//Alert Pagination code
		
		$scope.paginationCodeForUserAlert = function(page){
			 
			$scope.pages = Math.ceil($scope.platformNotificationList[0].totalCount);
			
				$scope.pages = Math.ceil($scope.pages / 10);
				
				
				$scope.numArray = [];
				$scope.firstVal = null;

				for (var i = 1; i <= $scope.pages; i++) {
					$scope.numArray.push(i);
				}
				$scope.firstVal = page;
		 }
		
		$scope.readAll = function() {
	
			var type = "";
			if ($scope.platformNotificationList.length > 0) {
				if ($scope.tabid == '') {
					type = "ALL";
				} else {
					type = $scope.tabid;
				}
				CompanyIndAlertService
						.readAllPlatformsAlert(type)
						.then(
								function(result) {

									$scope.userPlatformNotificationDetails(1);
									//$scope.paginationCodeForUserAlert(page);									
									
									$scope.userNotification.platformNotificationList = [];
									$timeout(
											function() {
												$rootScope
														.$emit("callTopFiveNotification");
											}, 100)
								},
								function(response, status, headers, config) {
									vm.entityResponse = response.data;
									$scope.errorMessage = vm.entityResponse.message;
									//	 $scope.errorMessage = "Error occured while read all Notification"
									$scope.error = true;
									$timeout(function() {

										$scope.error = false;
										$scope.errorMessage = "";

									}, 2000);

								});

			}

		}
		
		$scope.readPagination = function(page){
			
			$scope.pags = page;
			$scope.readAll($scope.pags);
		}

		$rootScope.$on("callUserLastSevenDaysNotifications", function() {
			$scope.userPlatformNotificationDetails(1);
		});

		$scope.userPlatformNotificationDetails(1);

	}
})();
